import { render } from "./TheSNSIcons.vue?vue&type=template&id=5f09fc36"
import script from "./TheSNSIcons.vue?vue&type=script&lang=js"
export * from "./TheSNSIcons.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__